import { Link } from "react-router-dom";
import { useI18n } from "../../lib/i18n";

// Placeholder logo: swap the <LogoMark /> for an SVG logo later.
export const LogoMark = ({ size = 40 }) => (
  <svg width={size} height={size * 0.72} viewBox="0 0 50 36" aria-hidden="true">
    <path d="M25 8C19 3 9 2 2 4v26c7-2 17-1 23 4V8z" fill="#1565D8" />
    <path d="M25 8c6-5 16-6 23-4v26c-7-2-17-1-23 4V8z" fill="#1565D8" opacity="0.85" />
    <path d="M2 30c7-2 17-1 23 4 6-5 16-6 23-4v2c-7-2-17-1-23 4-6-5-16-6-23-4z" fill="#FFC72C" />
  </svg>
);

export const Logo = ({ light = false, showTagline = true, testid = "logo-link" }) => {
  const { t } = useI18n();
  return (
    <Link to="/" className="flex items-center gap-3" data-testid={testid}>
      <LogoMark />
      <span className={`text-2xl font-extrabold tracking-tight ${light ? "text-white" : "text-osk-navy"}`}>Onskola</span>
      {showTagline && (
        <span className={`hidden max-w-[150px] text-xs font-medium leading-tight lg:block ${light ? "text-white/80" : "text-osk-navy"}`}>{t("tagline")}</span>
      )}
    </Link>
  );
};
